import { Reveal, SectionHeading } from "@/components/motion/Reveal";

const STATS = [
  { value: "30+", label: "Anni di esperienza" },
  { value: "1994", label: "Anno di fondazione" },
  { value: "2", label: "Città in Italia" },
];

const About = () => (
  <section id="chi-siamo" className="bg-ivory py-24 sm:py-32" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading index="01" eyebrow="Chi Siamo" title="Il Professionista e la Filosofia dello Studio" />

      <div className="mt-16 grid gap-14 lg:grid-cols-2 lg:gap-20 items-start">
        <Reveal className="relative">
          <div className="absolute -top-4 -left-4 h-full w-full border border-gold/50" />
          <div className="relative overflow-hidden">
            <img
              src="/brand/avvocato-3.jpg"
              alt="Avv. Giuseppe Napolitano"
              className="aspect-[4/5] w-full object-cover object-top transition-transform duration-700 hover:scale-[1.03]"
              data-testid="about-portrait"
            />
          </div>
          <div className="absolute -bottom-6 -right-3 sm:-right-6 bg-navy px-7 py-5 shadow-xl">
            <p className="font-serif text-3xl text-gold">dal 1994</p>
            <p className="mt-1 text-[11px] uppercase tracking-[0.25em] text-slate-300">Al servizio del diritto</p>
          </div>
        </Reveal>

        <div className="flex flex-col gap-6">
          <Reveal delay={0.1}>
            <p className="border-l-2 border-gold pl-6 font-display text-xl sm:text-2xl italic leading-relaxed text-navy">
              «Il rigore tecnico, unito a una visione moderna, al servizio delle specifiche esigenze di ogni cliente.»
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-base sm:text-lg leading-relaxed text-slate-600">
              L'Avvocato Giuseppe Napolitano nasce a Napoli il 29 aprile 1968, città in cui compie il proprio percorso di studi.
              Nel 1994 consegue la laurea in Giurisprudenza presso la prestigiosa Università degli Studi di Napoli Federico II.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="text-base sm:text-lg leading-relaxed text-slate-600">
              Questo solido background accademico, unito a oltre trent'anni di esperienza e costante aggiornamento, gli ha permesso
              di sviluppare una profonda competenza e un approccio strategico nella risoluzione delle controversie legali, sia in sede
              giudiziale che stragiudiziale. Lo studio coniuga il rigore tecnico con una visione moderna e orientata alle specifiche
              esigenze di ogni cliente.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="mt-4 grid grid-cols-3 gap-px bg-navy/10 border border-navy/10" data-testid="about-stats">
              {STATS.map((s) => (
                <div key={s.label} className="bg-white px-4 py-6 text-center">
                  <p className="font-serif text-3xl sm:text-4xl text-navy">{s.value}</p>
                  <p className="mt-2 text-[11px] uppercase tracking-[0.2em] text-slate-500">{s.label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default About;
